import { loginRequest } from 'src/config';
import { callMsGraph, callMsGraphGetUserPhoto, callMsGraphGroups } from 'src/graph';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from 'src/config';

const getInstance = () => {
  if (typeof window !== 'undefined') {
    if (!window.__msalInstance) {
      window.__msalInstance = new PublicClientApplication(msalConfig);
    }
    return window.__msalInstance;
  }
  return new PublicClientApplication(msalConfig);
};

const instance = getInstance();

export async function getUserInfo() {
  var user;

  await instance.initialize();

  const accounts = instance.getAllAccounts();
  const activeAccount = instance.getActiveAccount() || accounts[0];

  if (!activeAccount) {
    throw new Error('No account available for token acquisition');
  }

  await instance
    .acquireTokenSilent({
      ...loginRequest,
      account: activeAccount,
    })
    .then(async (response) => {
      await callMsGraph(response.accessToken).then((response) => (user = response));
      await callMsGraphGetUserPhoto(response.accessToken).then((response) => {
        user.avatar = response;
      });

      await callMsGraphGroups(response.accessToken).then(
        (response) => (user.groups = response.value.map((group) => group.displayName)),
      );
      if (localStorage.getItem('auth') !== response.accessToken) {
        localStorage.setItem('auth', response.accessToken);
      }
    });

  return user;
}

export async function saveFreshAccessTokenInLocalStorage() {
  await instance.initialize();

  const accounts = instance.getAllAccounts();
  const activeAccount = instance.getActiveAccount() || accounts[0];

  if (!activeAccount) {
    console.warn('No account available for token acquisition, skipping token refresh');
    return;
  }

  try {
    await instance
      .acquireTokenSilent({
        ...loginRequest,
        account: activeAccount,
      })
      .then(async (response) => {
        localStorage.setItem('auth', response.accessToken);
      });
  } catch (error) {
    console.warn('Failed to acquire token silently:', error);
  }
}
